export default __webpack_public_path__ + "static/media/step-bg3.a084a0fe.png";